import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Course } from 'src/app/models/course';
import { CourseEnrollment } from 'src/app/models/course-enrollment';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'li-course-enroll',
  templateUrl: './course-enroll.component.html',
  styleUrls: ['./course-enroll.component.scss'],
  standalone: true,
  imports: [DatePipe]
})

export class CourseEnrollComponent {
  @Input() course?: Course;
  @Input() students: CourseEnrollment[] = [];
  @Input() readOnly: boolean = true;

  @Output() closing = new EventEmitter<void>();

  close(): void {
    this.closing.emit();
  }
}

